module.exports = __webpack_public_path__ + "static/img/ry1.77e522da.png";